import { useCallback, useState } from 'react';

import TokenForm from '../forms/TokenForm';
import Dialog from './Dialog';
import Modal from './Modal';

interface TokenModalProps {
    closesOnSuccess?: boolean;
    onClose?: () => void;
    onComplete?: (user: Participant) => void;
}

function TokenModal({
    closesOnSuccess = false,
    onClose = null,
    onComplete = null,
    ...props
}: TokenModalProps) {
    const [opened, setOpened] = useState(true);
    const onRequestClose = useCallback(() => {
        setOpened(false);
    }, []);

    const onSuccess = useCallback(
        (user) => {
            if (closesOnSuccess) {
                onRequestClose();
            }

            if (onComplete !== null) {
                onComplete(user);
            }
        },
        [closesOnSuccess, onRequestClose, onComplete],
    );

    return (
        <Modal withSafe opened={opened} onClosed={onClose}>
            <Dialog withCloseButton onClickClose={onRequestClose}>
                <TokenForm onSuccess={onSuccess} onClickClose={onRequestClose} {...props} />
            </Dialog>
        </Modal>
    );
}

export default TokenModal;
